
import React, { useState } from "react";
import { MessageSquare, X } from "lucide-react";

const WhatsAppButton = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const phoneNumber = "5569992083972";
  const message = encodeURIComponent("Olá gostaria de saber mais sobre o LextPrompt");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          togglePopup();
        }}
        href={whatsappUrl}
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg z-50 flex items-center justify-center transition-all hover:scale-110 group cursor-pointer"
        aria-label="Contato pelo WhatsApp"
      >
        <MessageSquare size={28} />
        <span className="absolute right-full mr-3 bg-white text-gray-800 px-3 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Fale conosco
        </span>
      </a>

      {isPopupOpen && (
        <div className="fixed bottom-24 right-6 bg-white rounded-lg shadow-xl z-50 w-80 overflow-hidden border border-gray-200">
          <div className="flex items-center justify-between bg-green-500 text-white p-4">
            <div className="flex items-center">
              <MessageSquare className="mr-2" size={24} />
              <h3 className="font-medium">WhatsApp</h3>
            </div>
            <button onClick={closePopup} className="text-white hover:bg-green-600 rounded-full p-1">
              <X size={20} />
            </button>
          </div>
          <div className="p-4">
            <p className="text-gray-700 mb-4">
              Olá! Envie uma mensagem para falar com nosso time de atendimento.
            </p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-green-500 hover:bg-green-600 text-white text-center py-3 px-4 rounded-md font-medium transition-colors"
              onClick={closePopup}
            >
              Iniciar Conversa
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
